export default [
  {
    header: 'navbars.references',
    permission: ['content_management', 'super_manager'],
    unique_name: 'references-sale-offices',
  },

  {
    title: 'navbars.sales_departments',
    route: 'sale-offices',
    icon: 'ArchiveIcon',
    permission: ['content_management', 'super_manager'],
    unique_name: 'references-sale-offices',
  },
  {
    title: 'navbars.developers',
    icon: 'ToolIcon',
    route: 'constructors',
    permission: ['content_management', 'super_manager'],
    unique_name: 'references-constructors',
  },
  {
    title: 'navbars.contract_templates',
    icon: 'ClipboardIcon',
    route: 'contract-templates',
    permission: ['content_management', 'super_manager'],
    unique_name: 'references-contract-templates',
  },
  {
    title: 'navbars.project_staff',
    icon: 'UserIcon',
    route: 'project-staff',
    permission: ['content_management', 'super_manager'],
    unique_name: 'references-project-staff',
  },
]